export const colors = {
    // brand / base
    white: "#ffffff",
    nearWhite: "#fefefe",
    gray: "#D3D3D3",
    orange: "#F05A30",
    orangeLighter: "#f36a33",    // brand bar / sidebar header background
    orangeDark: "#d44a22",       // darker orange — gradient endpoint for avatars/buttons
    black: "#000000de",
    pureBlack: "#000000",
    nearBlack: "#222",
    softBlack: "#0a0a0a",        // item / sub-item title text (near-black)
    midGray: "#999999",          // medium grey — active/press state
    warning: "#ffbc20",
    grid: "#feecda",
    gridOpacity: "#feecda69",
    link: "#1890ff",
    blue: '#4c92f5e8',
    red: '#FF0000',
    green: '#008000',
    yellow: '#F9E14B',
    darkGreen: "#2e7d32",
    amber: "#f57f17",
    darkRed: "#c62828",
    deepRed: "#b71c1c",          // deep red — danger/logout hover
    blueIconBg: "#E3F2FD",
    purpleIconBg: "#F3E5F5",
    // semantic / UI states
    accentOrange: "#ed6c02",
    errorLight: "#e53935",
    errorDark: "#d32f2f",
    successMid: "#43a047",
    warningMid: "#fb8c00",
    warningBg: "#fff8e1",
    warningBorder: "#f9a825",
    warningDarkText: "#6d4c00",
    approveGreen: "#00ad45",
    rejectRed: "#ff322e",
    notifBadgeRed: "#ff3d3d",    // notification badge
    completedGreen: "#45c65a",
    inProgressYellow: "#edd90b",
    hoverBg: "#f0f4ff",
    muiBlue: "#1976d2",          // MUI default primary blue — unread notification dot
    alertBg: "#f5be58",          // amber-yellow alert background
    toggleBg: "#f49068b0",       // sidebar collapse toggle background (with alpha)
    orangeFaded: "#f05a30a5",    // orange with heavy alpha — link hover
    orangeRadioBg: "#f05a30b3",  // radio-checked inner fill (with alpha)
    orangeRadioBorder: "#f05a30b4", // radio-checked inner border (with alpha)
    rowSelectedBg: "#f0b4a321",  // ant-table row selected highlight (with alpha)
    // text
    textEnabled: "#212121",
    textDark: "#333",
    textMid: "#666",
    mutedText: "#777",
    subText: "#888",
    textDisabledMid: "#9e9e9e",  // also covers disabledText (#a0a0a0)
    dimText: "#555",
    charcoal: "#2d2d2d",         // medium-dark body text
    deepNavy: "#1a1a2e",         // very dark navy — headings / notification titles
    placeholder: "#aaa",
    deepGray: "#424242",
    hyperlink: "#337ab7",
    navyDark: "#041f36",
    // surfaces / backgrounds
    surfaceGray: "#f5f5f5",
    surfaceLight: "#fafafa",     // also covers softBg (#f9f9f9)
    redTint: "#fff5f5",
    orangeTint: "#fff5ee",
    orangeTintLight: "#fff0eb",  // light orange tint — notification icon gradient start
    orangeTintDark: "#ffe0d6",   // medium orange tint — notification icon gradient end
    orangeIconHoverBg: "#ffe6de", // icon background on hover in menus
    profileHeaderBg: "#fff5f2",  // profile header bg / menu item hover
    notifHoverBg: "#fdf6f4",     // notification row hover background
    notifUnreadBg: "#fff9f7",    // unread notification row background
    confirmBg: "#fff9f5",
    warmBg: "#fff8f0",
    pageBg: "#f5f5f3",           // warm grey main page background
    spinnerTrack: "#f3f3f3",     // loading spinner track ring
    lightBlue: "#add8e6",
    disabledBg: "#e3e3e3",
    fileDisabledBg: "#afaeae85", // disabled file-input background (with alpha)
    // borders
    borderLight: "#e0e0e0",      // also covers tagBg (#e1e1e1)
    borderMedium: "#e8e8e8",
    borderLighter: "#eee",
    borderLightest: "#ddd",
    borderFaint: "#f0f0f0",      // very light separator lines and borders
    borderPale: "#f4f4f4",       // pale border / divider
    warmBorder: "#f0e0d6",       // warm-toned section border (dispatch header)
    profileHeaderBorder: "#f5f0ee", // profile header bottom border
    sidebarBorder: "#e7e5df",    // sidebar main border
    sidebarBorderSoft: "#f1efe9", // sidebar soft border
    inputBorder: "#ccc",
    inputBorderAlt: "#c4c4c4",
    subtleBorder: "#33333314",
    semiBlack: "#0000008c",
    fileDisabledText: "#33333383", // disabled file-input text (with alpha)
    disabledIcon: "#00000042",
    tooltipBg: "#646464E6",
    mediumGray: "#757575",
    // misc UI
    grayLight: "#BDBDBD",
    scrollbarTrack: "#f1f1f1",
    chipBg: "#ffe5cb",
    chipText: "#3C2F2F",
    chipDeleteIcon: "#ff8462",
    scrollBtnBg: "#f78868",      // horizontal-scroll arrow button background
    shadowPink: "#D6C5C0",       // popover / menu box-shadow tone
    // calendar
    calHeaderBg: "#fce8e0",
    calSelectedDay: "#a5d6a7",
    calSelectedText: "#1b5e20",
    // scrollbar
    scrollbarThumb: "#00000040",
    // sidebar text / surface colours
    sidebarText: "#2c2a28",
    sidebarTextSoft: "#3a3935",
    sidebarMuted: "#5b5a55",
    // sidebar department accent colours
    steelBlue:          "#3F72AF",
    steelBlueTint:      "#3F72AF1F",
    steelBlueCsh:       "#3F72AF38",
    teal:               "#0D7C66",
    tealTint:           "#0D7C661F",
    tealCsh:            "#0D7C6638",
    rose:               "#D4537E",
    roseTint:           "#D4537E1F",
    roseCsh:            "#D4537E38",
    sienna:             "#E0542B",
    siennaTint:         "#E0542B1F",
    siennaCsh:          "#E0542B38",
    saffron:            "#B9791A",
    saffronTint:        "#B9791A1F",
    saffronCsh:         "#B9791A38",
    azure:              "#2F86D6",
    azureTint:          "#2F86D61F",
    azureCsh:           "#2F86D638",
    violet:             "#6C5DD3",
    violetTint:         "#6C5DD31F",
    violetCsh:          "#6C5DD338",
    emerald:            "#1D9E75",
    emeraldTint:        "#1D9E751F",
    emeraldCsh:         "#1D9E7538",
    graphite:           "#5F5E5A",
    graphiteTint:       "#5F5E5A1F",
    graphiteCsh:        "#5F5E5A38",
    // ── alpha / overlay / shadow tones ───────────────────────────────────────
    // MUI blue pulse animation
    muiBlueGlow:      "#1976D266",   // #1976D2 @ 40% — pulse shadow start
    muiBlueGlowFade:  "#1976D200",   // #1976D2 @ 0%  — pulse shadow end
    orangeShadow35:   "#F05A3059",   // #F05A30 @ 35% — brand shadow (appbar, avatars)
    orangeOverlay8:   "#F05A3014",   // #F05A30 @ 8%  — subtle orange hover bg
    darkRedOverlay8:  "#C6282814",   // #C62828 @ 8%  — logout hover bg
    warmShadow8:      "#221E1C14",   // #221E1C @ 8%  — sidebar rail shadow
    navyShadow16:     "#0F172A29",   // #0F172A @ 16% — flyout drop shadow
    overlayBg:        "#00000099",   // black @ 60%   — page loading overlay
    // black alpha family (box-shadow / scrollbar / border)
    blackAlpha5:      "#0000000D",   // black @ 5%
    blackAlpha10:     "#0000001A",   // black @ 10%
    blackAlpha15:     "#00000026",   // black @ 15%
    blackAlpha20:     "#00000033",   // black @ 20%
    blackAlpha30:     "#0000004D",   // black @ 30%
    // white alpha family (icon/chip surfaces on brand bar)
    whiteAlpha15:     "#FFFFFF26",   // white @ 15% — user chip bg
    whiteAlpha20:     "#FFFFFF33",   // white @ 20% — user chip border
    whiteAlpha25:     "#FFFFFF40",   // white @ 25% — user chip hover bg
    whiteAlpha75:     "#FFFFFFBF",   // white @ 75% — role text on dark bar
    whiteAlpha90:     "#FFFFFFE6",   // white @ 90% — small avatar bg on dark bar
}
